import { Employee } from './employee';
import { Project } from './project';

export interface Task {
  id: string;
  name: string;
  projectId: string;
  isAMS: boolean;
  project: Project;
  status: string;
  employees: Employee[];
}

export const taskStatusOptions = [
  'Unstarted',
  'Working',
  'Finished',
  'Abandoned',
];
